import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { SutraType, SutrapathService } from './sutrapath.service';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AccordionVM } from '../accordion/accordion.model';
import { tap, map, switchMap, scan, mapTo, distinctUntilChanged, reduce, mergeAll, exhaustMap, expand, mergeMap, concatMap } from 'rxjs/operators';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-sutrapath',
  templateUrl: './sutrapath.component.html',
  styleUrls: ['./sutrapath.component.css']
})
export class SutrapathComponent implements OnInit, AfterViewInit {
  stype: SutraType = SutraType.achar;
  sutras = new BehaviorSubject<AccordionVM[]>([]);
  title: any;
  isProgress = new BehaviorSubject<boolean>(true);
  isSutraPath = false;

  html = '';
  result = '';
  speech: any;
  speechData: any;

  constructor(private sutrapathService: SutrapathService, private route: ActivatedRoute, private router: Router,
    private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.isProgress.next(true)
    const type = this.route.snapshot.paramMap.get('stype')?.toString();
    this.stype = SutraType[type as keyof typeof SutraType];

    if (this.stype == SutraType.drustant) {
      this.metaManager.updateMetaTitle("दृत्तांत | Mahanubhav Panth | sarvadhnya.com",
        "Mahanubhav Panth drustant path (दृत्तांत) read online, free download, keyword search",
        "दृत्तांत, drusthanta, drustant path, Chakradhar swami sthan, Mahanubhav, mahanubhav panth");

      this.title = "दृत्तांत";
      this.isSutraPath = false;
      var v = this.sutrapathService.getdrustant(this.stype).subscribe(result => {
        var v = this.sutras.getValue().concat(result);
        this.sutras.next(v);
        this.isProgress.next(false);
      });
    }
    else {
      this.metaManager.updateMetaTitle("सूत्रपाठ | Mahanubhav Panth | sarvadhnya.com",
        "Mahanubhav Panth sutrapath (सूत्रपाठ - नवप्रकरण, आचार, आचार मालिका, विचार, विचार मालिका) read online, free download, keyword search",
        "सूत्रपाठ, नवप्रकरण, आचार, आचार मालिका, विचार, विचार मालिका, Mahanubhav Panth, Mahanubhav nauprakaran, achar, achar malika, vichar, vichar malika");

      this.isSutraPath = true;
      this.title = "सूत्रपाठ";

      this.stype = SutraType[type as keyof typeof SutraType];
      var v = this.sutrapathService.getSutra(this.stype).subscribe(result => {
        var v = this.sutras.getValue().concat(result);
        this.sutras.next(v);
        this.isProgress.next(false);
      });
    }
  }

  ngAfterViewInit(): void {
    Array.from(document.getElementsByClassName("nav-link")).forEach(element => {
      element.classList.remove("active");
      var v = element as HTMLAnchorElement;
      if (v.href.endsWith(SutraType[this.stype].toString()))
        element.classList.add("active");
    });
  }
}

